/**
 * JSON Schema Generator — Tool Manifest
 */
import type { ToolManifest } from "../../../lib/tool";

export const manifest: ToolManifest = {
  id: "json-schema-generator",
  name: "JSON Schema Generator",
  description: "Generate JSON Schema from JSON data. Draft 7, 2020-12, with type inference.",
  category: "developer",
  keywords: ["json schema", "schema generator", "json to schema", "json schema gen"],
  icon: "FileCode",
  requiresNetwork: false,
  seo: {
    title: "JSON Schema Generator — 100% Private, Offline | UnQTools",
    faq: [
      { q: "What does this tool do?", a: "Generate JSON Schema from JSON data. Draft 7, 2020-12, with type inference." },
      { q: "Is my data sent to a server?", a: "No. This tool runs 100% in your browser. Nothing is uploaded, tracked, or stored remotely." },
      { q: "What extra features does this tool have?", a: "Extras: (1) Drag-and-drop file upload; (2) Bulk processing; (3) Live preview; (4) Multiple format support; (5) Quality/size controls; (6) Preset configurations; (7) Export as ZIP; (8) Copy to clipboard; (9) History (localStorage); (10) PWA offline; (11) Privacy-first; (12) WCAG compliant." },
      { q: "Does this work offline?", a: "Yes — install as a PWA and use it without network." },
    ],
  },
  status: "planned",
};
